import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { GraduationCap } from "lucide-react";
import api from "@/lib/api";

export function Footer() {
  const [pages, setPages] = useState([]);
  useEffect(() => {
    api.get("/public/menu-pages").then((r) => setPages(r.data.footer || [])).catch(() => {});
  }, []);
  return (
    <footer className="mt-20 border-t border-slate-200 bg-slate-50">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
          <div className="col-span-2 md:col-span-1">
            <img src="/oed-logo.gif" alt="Online Education Directory" className="h-8 w-auto" />
            <p className="mt-3 text-sm text-slate-500">
              An independent directory to discover online degrees, diplomas and professional programmes worldwide.
            </p>
          </div>
          <div>
            <h4 className="mb-3 text-sm font-semibold text-slate-900">Explore</h4>
            <ul className="space-y-2 text-sm text-slate-500">
              <li><Link to="/courses" className="hover:text-blue-800">Find Courses</Link></li>
              <li><Link to="/universities" className="hover:text-blue-800">Universities</Link></li>
              <li><Link to="/countries" className="hover:text-blue-800">Countries</Link></li>
              <li><Link to="/categories" className="hover:text-blue-800">Categories</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="mb-3 text-sm font-semibold text-slate-900">Institutions</h4>
            <ul className="space-y-2 text-sm text-slate-500">
              <li><Link to="/for-universities" className="hover:text-blue-800">For Universities</Link></li>
              <li><Link to="/pricing" className="hover:text-blue-800">Listing Plans</Link></li>
              <li><Link to="/register" className="hover:text-blue-800">Register Institution</Link></li>
              <li><Link to="/login" className="hover:text-blue-800">University Login</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="mb-3 text-sm font-semibold text-slate-900">Company</h4>
            <ul className="space-y-2 text-sm text-slate-500">
              {pages.length > 0 ? (
                pages.map((p) => (
                  <li key={p.slug}><Link to={`/page/${p.slug}`} className="hover:text-blue-800">{p.title}</Link></li>
                ))
              ) : (
                <>
                  <li><Link to="/page/about" className="hover:text-blue-800">About</Link></li>
                  <li><Link to="/page/terms" className="hover:text-blue-800">Terms & Conditions</Link></li>
                  <li><Link to="/page/privacy" className="hover:text-blue-800">Privacy Policy</Link></li>
                </>
              )}
            </ul>
          </div>
        </div>
        <div className="mt-10 space-y-3 border-t border-slate-200 pt-6 text-xs text-slate-400">
          <p>
            Online Education Directory is an independent education information and directory platform.
            Course information, fees, eligibility and programme details are provided for informational purposes
            and may change. Visitors should verify the latest information directly with the respective institution.
          </p>
          <p>
            Online Education Directory does not process student admissions and does not provide admission counselling
            or collect student enquiries.
          </p>
          <p>© {new Date().getFullYear()} Online Education Directory. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
